import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const TogSendList = lazy(() => import('./pages/TogSendList'));
const TogSendView = lazy(() => import('./pages/TogSendView'));
const CreateTog = lazy(() => import('./pages/CreateTog'));

const togSendRoutes: RouteObject[] = [
  {
    index: true,
    element: <TogSendList />,
  },
  {
    path: 'new',
    element: <CreateTog />,
  },
  {
    path: ':id',
    element: <TogSendView />,
  },
];

export default togSendRoutes;
